import { Router } from '@angular/router';
import { filter, switchMap } from 'rxjs/operators';
import { Component, Input } from '@angular/core';

import { DoodProductModel } from '@core/models/product.model';
import { SettingsStoreSelector } from '@common/selectors/settings.selector';
import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { SuggestionsSetsService } from '@core/services/suggestions-sets/suggestions-sets.service';
import { Observable, ReplaySubject } from 'rxjs';
import { AnalyticsService } from '@core/services/app/analytics.service';

@Component({
  selector: 'app-cart-suggestion-cards-block',
  templateUrl: './cart-suggestion-cards-block.component.html',
})
export class CartSuggestionCardsBlockComponent {
  @Input() heading?: string;
  @Input() leading?: string;
  @Input() set suggestionsSet(value: string | undefined) {
    this._suggestionsSet$.next(value);
  }
  private readonly _suggestionsSet$ = new ReplaySubject<string | undefined>(1);

  protected readonly isMobile$ = this.settingsSelector.selectDeviceIsMobileScreen;

  protected readonly suggestions$: Observable<DoodProductModel[]> = this._suggestionsSet$.pipe(
    filter(suggestionsSet => !!suggestionsSet),
    switchMap(suggestionsSet =>
      this.suggestionsSetsService.getSuggestionsSet$(suggestionsSet as string),
    ),
  );

  constructor(
    private readonly router: Router,
    private readonly settingsSelector: SettingsStoreSelector,
    private readonly routerHelper: RouterHelperService,
    private readonly suggestionsSetsService: SuggestionsSetsService,
    private readonly analyticsService: AnalyticsService,
  ) {}

  productClick(product: DoodProductModel): void {
    this.analyticsService.log({
      level: 'debug',
      label: '#DOOD-1250 Navigate',
      message: {
        from: 'CartSuggestionCardsBlockComponent Ligne°41',
        target: [
          this.routerHelper.translateRoute(`cart/products/${product.shop_id}/${product.id}`),
        ],
        currentLocation: window.location.pathname,
      },
    });
    this.router.navigate([
      this.routerHelper.translateRoute(`cart/products/${product.shop_id}/${product.id}`),
    ]);
  }
}
